import { inject, Injectable } from '@angular/core';
import { LocalStorageService } from '@app/core/services/local-storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class SessionMarkerService {
  private localStorageService: LocalStorageService = inject(LocalStorageService);

  private readonly localStoreKey = 'session';
  private readonly sessionActiveValue = 'active';

  public isSessionActive() {
    const savedSessionActiveValue = this.localStorageService.getFromLS(this.localStoreKey);

    return savedSessionActiveValue === this.sessionActiveValue;
  }

  public setSessionActive() {
    this.localStorageService.saveToLS(this.localStoreKey, this.sessionActiveValue);
  }

  public deleteSessionState() {
    this.localStorageService.removeFromLS(this.localStoreKey);
  }
}
